import { render } from "./waitingDriversNumber.vue?vue&type=template&id=366aa8c3&scoped=true"
import script from "./waitingDriversNumber.vue?vue&type=script&lang=js"
export * from "./waitingDriversNumber.vue?vue&type=script&lang=js"

import "./waitingDriversNumber.vue?vue&type=style&index=0&id=366aa8c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-366aa8c3"]])

export default __exports__